import styled, { css } from 'styled-components';
import { Avatar, ButtonAppearance, Button, ButtonSize } from '@bechtel/gds';

export const AvatarRegularStyled = styled(Avatar)`
  border-width: 0px;
`;
export const CloseRequestButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.MEDIUM,
})`
  ${({ theme }) => css`
    border-radius: ${theme.spacings['200']};
    background: ${theme.colors.white};
    color: ${theme.colors.red['500']};
    font-size: ${theme.fontSizes['400']};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `};
`;
